/**
 * Created by Administrator on 2019/2/20.
 */
import request from '@/common/ajax'
import api from './api';

export default {
  /**
   *
   *  查询活动列表
   *
   */
  campaignPage(data){
    return  api.getSync('api/campaign/page',data||{});
  },
  /**
   * 活动详情
   */
  campaignDetail(data){
    return  request('api/campaign/detail',data||{},'GET')
  },
  /**
   * 活动详情参与成员分页接口
   */
  campaignDetailMember(data){
    return  request('api/campaign/queryCampMember',data||{},'GET')
  },
  /**
   * 活动审批接口
   */
  campaignAudit(data){
    return  request('api/campaign/audit',data||{},'POST')
  },
  /**
   * 活动提交接口
   */
  campaignSubmit(data){
    return  request('api/campaign/submit',data||{},'POST')
  },
  /**
   * 生成活动pdf
   */
  campaignPdf(data){
    return  request('api/campaign/generatePdf',data||{},'GET')
  },
  /**
   * 活动作品详情
   */
  campaignDetailWorks(data){
    return  request('api/campaign/detailWorks',data||{},'GET')
  },
  /**
   * 活动作品点评接口
   */
  campaignSaveWorksReview(data){
    return  request('api/campaign/saveWorksReview',data||{},'GET')
  },
  /**
   *
   *  查询活动报告列表
   *
   */
  reportPage(data){
    return  request('api/campaignReport/page',data||{},'GET')
  },
  /**
   *
   *  查询活动报告详情
   *
   */
  reportDetail(data){
    return  request('api/campaignReport/detail',data||{},'GET')
  },
  /**
   * 生成活动报告pdf
   */
  reportPdf(data){
    return  request('api/campaignReport/generatePdf',data||{},'GET')
  },
  /**
   * 生成活动报告审批
   */
  reportAudit(data){
    return  request('api/campaignReport/audit',data||{},'GET')
  },
  /**
   * 活动报告提交
   */
  reportSubmit(data){
    return  request('api/campaignReport/submit',data||{},'POST')
  },
  /**
   * 30天后活动提交
   */
  submitSaleAfterMonth(data){
    return  request('api/campaignReport/submitSaleAfterMonth',data||{},'POST')
  },
}



// WEBPACK FOOTER //
// ./src/api/active.js